import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

import { SectionIds } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly _router = inject(Router);
  private readonly _platformId = inject(PLATFORM_ID);

  navigateToItem(link: SectionIds | string, isSectionId: boolean): void {
    if (!isPlatformBrowser(this._platformId)) return;

    if (isSectionId) {
      const section: HTMLElement = document.getElementById(link);

      if (section) {
        this._smoothScrollToSection(section);
      }
    } else {
      this._router.navigate([link]);
    }
  }

  private _smoothScrollToSection(section: HTMLElement): void {
    const sectionTop = section.getBoundingClientRect().top;
    const startPosition = window.scrollY;
    const targetPosition = sectionTop + startPosition;
    const animationTime = 400;
    const framesCount = 50;
    const scrollBy = (targetPosition - startPosition) / framesCount;

    let currentFrame = 0;

    const scroller = setInterval(() => {
      if (currentFrame < framesCount) {
        window.scrollBy(0, scrollBy);
        currentFrame++;
      } else {
        clearInterval(scroller);
        window.scrollTo(0, targetPosition);
      }
    }, animationTime / framesCount);
  }
}
